import { IDeleteFuncionariosTercUseCase } from "../../../presentation/useCases/delete/delete_funcionarios_terc_use_case";
import {  ITerceirizacaoRepository } from "../../repositories/terceirizacao_repository";

// DeleteFuncionariosTercUseCase

export class DeleteFuncionariosTercUseCase implements IDeleteFuncionariosTercUseCase {
  constructor(private readonly repository: ITerceirizacaoRepository) {}

  async deleteFuncionariosTerc(IdFuncionarioTerc: number): Promise<void> {
    await this.repository.deleteFuncionariosTerc(IdFuncionarioTerc);
  }
}
